import { render } from "./SidenavList.vue?vue&type=template&id=60c02557"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrew/Work/Projects/Pocketkey/qrdynamic/qrdynamic-admin/qrdynamic-admin-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__